import { Platform, usePlatform } from '@tofu/platform';
import { useFanforgeConfigs } from '@hotpot-arcade/fanforge-core-client';

export function useMediaUrl(relativePath: string | undefined): string {
  const config = useFanforgeConfigs();
  const { platform } = usePlatform();

  if (!relativePath) {
    return '';
  }

  return platform.platform === Platform.Web
    ? new URL(relativePath, config.assetsUrl).toString()
    : `/media/${relativePath}`;
}
